<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>子商户配置</h1>
        <p>“子商户产品查询”接口显示微信报备通过才可以调用“子商户配置”接口</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM7326</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>固定：mcht</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>固定：1</td></tr>
          <tr><td>渠道商户号</td><td>channelSecMchtNo</td><td>String(32)</td><td>是</td><td>通过“商户查询”接口得到商户在微信的商户号</td></tr>
          <tr><td>业务类型</td><td>busType</td><td>String(2)</td><td>是</td><td>01支付AppID, 02关注AppID, 03JSAPI授权目录</td></tr>
          <tr><td>支付appid类型</td><td>adddata1</td><td>String（32）</td><td>否</td><td>busType是01、02必填，枚举：00公众号，01小程序</td></tr>
          <tr><td>支付appid</td><td>adddata2</td><td>String（32）</td><td>否</td><td>busType是01、02必填，要配置的微信appid</td></tr>
          <tr><td>支付目录</td><td>adddata3</td><td>String（32）</td><td>否</td><td>busType是03必填</td></tr>
          <tr><td>关注appid(小程序、公众号)</td><td>appid</td><td>String（32）</td><td>否</td><td>busType是02必填</td></tr>
         </tbody>
        </table>
        <h4>请求示例</h4>
        <p>
          <code>
            支付appid配置
            {
            "trscode":"AGM7326",
            "mchtCd":"MCHT100011611",
            "proCd":"mcht",
            "chanelType":"1",
            "channelSecMchtNo":"101000000",
            "busType":"01",
            "adddata2":"1000000100",
            "adddata1":"00"
            }
          </code>
        </p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          </tbody>
        </table>
        <h4>应答示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshbbcx', 'name': '子商户报备查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Zshpz.vue